
    import { isTypingInExternalInput } from "@utils/keyboard";

    // ← and → click the pager links. A field, the live-screen frame, or an
    // open dialog keeps those keys. Esc blurs a field or the frame. Keypad
    // presses post into the frame; the embed bridge is the allowlist.
    function typingOrFrame() {
      return isTypingInExternalInput(null) || document.activeElement?.tagName === "IFRAME";
    }

    function dialogOpen() {
      return Array.from(document.querySelectorAll('[role="dialog"], [aria-modal="true"]')).some(
        (el) => el.offsetParent !== null || el.getClientRects().length > 0,
      );
    }

    export default {
      mounted() {
        this._onKeydown = (event) => {
          if (event.key === "Escape" && typingOrFrame()) {
            document.activeElement?.blur();
            return;
          }

          if (typingOrFrame() || dialogOpen()) return;
          if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) {
            return;
          }

          const id =
            event.key === "ArrowLeft" ? "pager-prev" : event.key === "ArrowRight" ? "pager-next" : null;
          const link = id && this.el.querySelector(`a#${id}`);
          if (!link) return;

          event.preventDefault();
          link.click();
        };

        this._onClick = (event) => {
          const frame = this.el.querySelector("iframe")?.contentWindow;
          if (!frame) return;

          const command = event.target.closest("[data-command]")?.dataset.command;
          if (command) {
            frame.postMessage({ type: "remote-press", command }, window.location.origin);
            return;
          }

          if (event.target.closest("[data-end-session]")) {
            frame.postMessage({ type: "embed-action", action: "end_session" }, window.location.origin);
          }
        };

        this._onMessage = (event) => {
          const frame = this.el.querySelector("iframe");
          if (!frame || event.origin !== window.location.origin || event.source !== frame.contentWindow) {
            return;
          }
          if (event.data?.type === "keyboard-released") frame.blur();
        };

        window.addEventListener("keydown", this._onKeydown);
        window.addEventListener("message", this._onMessage);
        this.el.addEventListener("click", this._onClick);
      },

      destroyed() {
        window.removeEventListener("keydown", this._onKeydown);
        window.removeEventListener("message", this._onMessage);
        this.el.removeEventListener("click", this._onClick);
      },
    };
  